import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'
import { HelmetProvider } from 'react-helmet-async'
import { installApiBase } from './lib/api'
import './index.css'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import App from './App.tsx'

// Route /api/* straight to the API origin instead of proxying through Vercel.
installApiBase()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <MantineProvider>
        <ModalsProvider>
          <Notifications position="bottom-right" />
          <App />
        </ModalsProvider>
      </MantineProvider>
    </HelmetProvider>
  </StrictMode>,
)
